import request from '../index';

const getToken = () => localStorage.getItem('userToken');

export const getDefaultAutoplayList = (movieID) =>
  request({
    url: `/movies/${movieID}/autoplay_list?token=${getToken()}`,
    method: 'GET',
    params: {
      limit: 5,
    },
  });

export const getSpecificSeriesAutoplayList = (movieId, seriesId) =>
  request({
    url: `/movies/${movieId}/autoplay_list?token=${getToken()}&series_id=${seriesId}`,
    method: 'GET',
  });

export const getSubseriesAutoplayList = (seriesId) =>
  request({
    url: `/movies/${seriesId}/autoplay_list?token=${getToken()}&subseries=true`,
    method: 'GET',
    params: {
      limit: 5,
    },
  });
